module.exports = __webpack_public_path__ + "static/media/icon-email.0a3a3edc.png";